//----this is playlist pitchment---

import "./rights.scss";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Grid,
  InputLabel,
  TextField,
  Box,
  Button,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
  Pagination,
  Typography,
  Fade,
  Card,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  API_URL,
  guidelinesTools,
  guidelinesToolsLyrics,
  trackTitleLanguage,
} from "../../constants";
import SelectCmp from "react-select";
import SaveIcon from "@mui/icons-material/Save";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CustomShowModal from "../../components/Common/CustomShowModal";
import { useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Instagram from "@mui/icons-material/Instagram";
import Facebook from "@mui/icons-material/Facebook";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PolicyIcon from "@mui/icons-material/Policy";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import HistoryIcon from "@mui/icons-material/History";
import { getHeaders, toastError, toastSuccess } from "../../utils";
import * as actions from "./actions";
import axios from "axios";
import SEO from "../../components/SEO";
const selectStyles = {
  control: (base, state) => ({
    ...base,
    background: "white",
    borderRadius: "8px",
    minHeight: "42px",
    borderColor: state.isFocused ? "#1a73e8" : "#e0e0e0",
    borderWidth: "2px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "1rem",
    boxShadow: "none",
    '&:hover': {
      borderColor: "#1a73e8",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: "#202124",
    fontFamily: "'DM Sans', sans-serif",
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#80868b",
    fontFamily: "'DM Sans', sans-serif",
  }),
  option: (defaultStyles, state) => ({
    ...defaultStyles,
    backgroundColor: state.isSelected ? "#1a73e8" : state.isFocused ? "#e3f2fd" : "white",
    color: state.isSelected ? "white" : "#202124",
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    '&:active': {
      backgroundColor: "#1a73e8",
    },
  }),
};

const whitelistPlatformOptions = [
  { value: "Youtube", label: "Youtube" },
  { value: "Soundcloud", label: "Soundcloud" },
];

const whitelistchannelOptions = [
  { value: "Artist Channel", label: "Artist Channel" },
  { value: "Label Channel", label: "Label Channel" },
];

const platformOptions = [
  { value: "Youtube Content ID", label: "Youtube Content ID" },
];

const policyOptions = [
  { value: "Monetize", label: "Monetize" },
  { value: "Remove", label: "Remove" },
  { value: "Block", label: "Block" },
];

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const moodsOptions = [
  "Chill",
  "Motivation",
  "Happy",
  "Energetic",
  "Sad",
  "Romantic",
  "Sexy",
  "Spirtual",
  "Relax",
  "None of these",
];

const PageContainer = styled(Box)({
  minHeight: 'calc(100vh - 64px)',
  background: 'linear-gradient(135deg, #e8eef3 0%, #dce4ec 100%)',
  padding: '32px 24px',
});

const PageHeader = styled(Box)({
  marginBottom: '32px',
  textAlign: 'center',
  '& h1': {
    fontSize: '2rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    fontFamily: "'DM Sans', sans-serif",
    margin: 0,
  },
});

const FormCard = styled(Card)({
  borderRadius: '16px',
  padding: '32px',
  background: 'white',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
  marginBottom: '32px',
});

const SectionTitle = styled(Typography)({
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '1.5rem',
  fontWeight: 700,
  color: '#202124',
  marginBottom: '24px',
  marginTop: '32px',
});

const StyledInputLabel = styled(InputLabel)({
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#202124',
  marginBottom: '8px',
  display: 'block',
});

const StyledButton = styled(Button)(({ theme }) => ({
  fontFamily: "'DM Sans', sans-serif",
  background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
  fontSize: '1rem',
  fontWeight: 600,
  height: 48,
  minWidth: 160,
  borderRadius: '12px',
  color: "white",
  textTransform: 'none',
  boxShadow: '0 4px 12px rgba(26, 115, 232, 0.3)',
  transition: 'all 0.3s ease',
  "&:hover": {
    background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
    boxShadow: '0 6px 20px rgba(26, 115, 232, 0.4)',
    transform: 'translateY(-2px)',
  },
}));

const WarningCard = styled(Box)({
  background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
  borderRadius: '16px',
  padding: '20px 24px',
  marginBottom: '24px',
  border: '2px solid #ff9800',
  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.15)',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '16px',
  '& .warning-icon': {
    color: '#f57c00',
    fontSize: '28px',
    marginTop: '2px',
  },
  '& .warning-content': {
    flex: 1,
    '& h4': {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '1.1rem',
      fontWeight: 700,
      color: '#e65100',
      marginBottom: '8px',
      marginTop: 0,
    },
    '& p': {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '0.95rem',
      fontWeight: 500,
      color: '#5d4037',
      lineHeight: 1.6,
      margin: 0,
      '& a': {
        color: '#1a73e8',
        textDecoration: 'none',
        fontWeight: 600,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
});

const CssTextField = styled(TextField)(({ theme }) => ({
  fontFamily: "'DM Sans', sans-serif",
  "& .MuiOutlinedInput-root": {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    fontFamily: "'DM Sans', sans-serif",
    "& fieldset": {
      borderColor: '#e0e0e0',
      borderWidth: '2px',
    },
    "&:hover fieldset": {
      borderColor: '#1a73e8',
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1a73e8",
      borderWidth: "2px",
    },
  },
  "& .MuiInputBase-input": {
    color: '#202124',
    fontFamily: "'DM Sans', sans-serif",
  },
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    color: "#5f6368",
    fontWeight: 600,
  },
  "& label.Mui-focused": {
    color: "#1a73e8",
  },
}));

const StyledTableContainer = styled(TableContainer)({
  borderRadius: '16px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
  backgroundColor: 'white',
  overflow: 'hidden',
  marginTop: '24px',
});

const StyledTableHead = styled(TableHead)({
  background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
  '& .MuiTableCell-head': {
    color: 'white',
    fontWeight: 700,
    fontSize: '0.95rem',
    fontFamily: "'DM Sans', sans-serif",
    borderBottom: 'none',
    padding: '16px',
  },
});

const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8f9fa',
  },
  '&:hover': {
    backgroundColor: '#e3f2fd',
    transition: 'all 0.2s ease',
  },
  '& .MuiTableCell-root': {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.9rem',
    color: '#202124',
    borderBottom: '1px solid #e0e0e0',
    padding: '14px 16px',
  },
});

const intitalUGCState = {
  release_id: "",
  release_title: "",
  audio_title: "",
  platform: "",
  policy: "",
  url: [], // multi url
};

const initialWhitelistState = {
  whitelist_id: "",
  platform: "",
  channel_type: "",
  channel_name: "",
  URL: "",
};

const intitalProfileState = {
  release_id: "",
  release_title: "",
  audio_title: "",
  artist: "",
  facebook_link: "", // single url
  instagram_link: "", // single url
};

const intitalPlaylistState = {
  release_id: 1,
  release_title: "",
  audio_title: "",
  press_release: [], // multi url
  social_media: [], // multi url
  artwork_asset: "", // single url
  additional_assets: "", // single url
  moods: [], // multi url
  why_pitch: "",
  quick_pitch: "",
  additional_info: "",
};

function isValidUrl(str) {
  const pattern = new RegExp(
    "^([a-zA-Z]+:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i"
  );
  return pattern.test(str);
}

export default function RightsManager(props) {
  const { setLoader = () => {} } = props;
  const { pathname } = useLocation();

  const [toolType, setToolType] = useState("ugc"); // ugc, profile, playlist
  const [releases, setReleases] = useState([]);
  const [songs, setSongs] = useState([]);
  const [dataHistory, setDataHistory] = useState([]);
  const [guidelinesOpen, setGuidelinesOpen] = useState(false);
  const [selectedRelease, setSelectedRelease] = useState(null);
  const [selectedSong, setselectedSong] = useState(null);
  const [data, setData] = useState(JSON.parse(JSON.stringify(intitalUGCState))); // deep clone
  const [modalViewType, setModalViewType] = useState({
    type: "",
    urls: [],
  }); // url, press, social, moods, facebook, instagram,  artwork, additional,
  const [modalContentView, setModalContentView] = useState({
    show: false,
    component: null,
  });
  const [viewDetailsModal, setViewDetailsModal] = useState(null);
  const [detailsData, setDetailsData] = useState();
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    limit: 20,
    offset: 0,
    page: 1,
  });
  const [lyricalData, setLyricalData] = useState({});

  useEffect(() => {
    setInitialData();
  }, [pathname]);

  useEffect(() => {
    onGetSongsByRelease();
  }, [selectedRelease]);

  let guidelinesToolsArray = "";
  if (toolType === "playlist") {
    guidelinesToolsArray = guidelinesTools;
  } else guidelinesToolsArray = guidelinesToolsLyrics;

  const setInitialData = async () => {
    try {
      let toolTypePath = "ugc";
      if (pathname === "/rights/whitelist") {
        toolTypePath = "whitelist";
        setData(JSON.parse(JSON.stringify(initialWhitelistState)));
      } else {
        toolTypePath = "ugc";
        setData(JSON.parse(JSON.stringify(intitalUGCState)));
      }
      setToolType(toolTypePath);
      if (toolTypePath !== toolType) {
        setDataHistory(null);
      }
      getInitialData(toolTypePath, filters);
      setSelectedRelease(null);
      setselectedSong(null);
    } catch (ex) {
      setLoader(false);
    }
  };

  const getInitialData = async (toolType, filters = {}) => {
    try {
      let releaseActions = Promise.resolve({});
      let historyAction = Promise.resolve({});
      if (toolType === "ugc") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getUGCClaimHistory;
      } else if (toolType === "whitelist") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getWhitelistHistory;
      }
      setLoader(true);
      const [{ body: releases = [] }, { body: dataHistory = [], total = 0 }] =
        await Promise.all([releaseActions(), historyAction(filters)]);
      setReleases(
        releases.map((item) => ({
          ...item,
          label: item.release_title,
          value: item.release_id,
        }))
      );
      setCount(total);
      setDataHistory(dataHistory);
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onGetSongsByRelease = async () => {
    try {
      if (!selectedRelease.release_id) return;
      setSongs([]);
      setselectedSong(null);
      setLoader(true);
      const { body: songs = [] } =
        (await actions.getAudioTitlesByReleaseId(selectedRelease.release_id)) ||
        {};
      setSongs(
        songs.map((item) => ({
          ...item,
          label: item.title,
          value: item.audio_id,
        }))
      );
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    getInitialData(toolType, newFilters);
  };

  const onHandleChange = (e = {}) => {
    const { name = "", value = "" } = e.target || {};
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const onHandleModalView = (type, urls = []) => {
    setModalViewType({
      type,
      urls: !urls.length && type !== "moods" ? [""] : urls,
    });
  };

  const onChangeUrls = (action, type, value, index) => {
    const updatedData = { ...data };
    if (type === "moods") {
      if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls.push(value);
        setModalViewType(prevdata);
      } else {
        const updatedMoods = modalViewType.urls.filter(
          (item) => item !== value
        );
        setModalViewType((prev) => ({ ...prev, urls: updatedMoods }));
      }
    } else {
      if (action === "add") {
        setModalViewType((prev) => ({ ...prev, urls: [...prev.urls, ""] }));
        updatedData[type].push("");
      } else if (action === "delete") {
        const prevdata = { ...modalViewType };
        prevdata.urls.splice(index, 1);
        setModalViewType(prevdata);
      } else if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls[index] = value;
        setModalViewType(prevdata);
      }
    }
  };

  const onAddUrls = () => {
    const { type, urls = [] } = modalViewType;
    if (type !== "moods") {
      if (!urls.length) return;
      for (let i = 0; i < urls.length; i++) {
        const isValid = isValidUrl(urls[i]);
        if (!isValid) {
          toastError(`Invalid URL at position ${i + 1}`);
          return;
        }
      }
    }
    const updatedData = { ...data };
    updatedData[type] = urls;
    setData(updatedData);
    setModalViewType({
      type: "",
      urls: [],
    });
  };

  const isValidLink = (text) => {
    try {
      const url = new URL(text);
      return ['http:', 'https:'].includes(url.protocol);
    } catch (err) {
      return false;
    }
  };

  const onSubmitForm = async () => {
    if (
      toolType !== "whitelist" &&
      (!selectedRelease || !selectedRelease?.label || !selectedSong?.label)
    ) {
      toastError(`Please fill all mandatory fields`);
      return;
    }
    try {
      let request = {};
      let sendObj =
        toolType !== "whitelist"
          ? {
              release_id: selectedRelease.value,
              release_title: selectedRelease.label,
              audio_title: selectedSong.label,
            }
          : {};

      if (toolType === "ugc") {
        if (
          !data.platform ||
          !selectedRelease ||
          !data.policy ||
          data?.url.length === 0 ||
          !sendObj.audio_title
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        sendObj = {
          ...sendObj,
          platform: data.platform,
          policy: data.policy,
          url: data.url,
        };
        request = actions.submitUGCClaim;
      } else if (toolType === "whitelist") {
        if (
          !data.whitelistPlatform ||
          !data.channel_type ||
          !data.channel_name ||
          !data.URL
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        if (!isValidLink(data.URL)) {
          toastError(`Please enter a valid link`);
          return;
        }
        sendObj = {
          platform: data.whitelistPlatform,
          channel_type: data.channel_type,
          channel_name: data.channel_name,
          URL: data.URL,
        };
        request = actions.submitWhitelist;
      }

      setLoader(true);
      await request(sendObj);
      setLyricalData({});
      setSelectedFileName("");
      await setInitialData();
      toastSuccess("Submission successful.");
    } catch (ex) {
      setLoader(false);
      toastError(ex.message);
    }
  };

  const renderModalViewContent = (renderType, content) => {
    let component = null;
    switch (renderType) {
      case "urls": {
        component = (
          <Box>
            {Array.isArray(content) && content.length
              ? content.map((item) => {
                  return (
                    <Box textAlign="center" mb={1}>
                      <a href={item} target="_blank">
                        {item}
                      </a>
                    </Box>
                  );
                })
              : null}
          </Box>
        );
        break;
      }
      case "": {
        // other cases
        component = <></>;
      }
      default:
        component = null;
    }
    setModalContentView({ show: true, component });
  };

  const selectedPolicy = useMemo(
    () => policyOptions.find((item) => item.value === data.policy),
    [data]
  );
  const selectedPlatform = useMemo(
    () => platformOptions.find((item) => item.value === data.platform),
    [data]
  );
  const selectedWhitelistPlatform = useMemo(
    () =>
      whitelistPlatformOptions.find(
        (item) => item.value === data.whitelistPlatform
      ),
    [data]
  );

  const selectedWhitelistChannel = useMemo(
    () =>
      whitelistchannelOptions.find((item) => item.value === data.channel_type),
    [data]
  );
  const heading = useMemo(() => {
    let heading = "UGC Claims";
    if (toolType === "whitelist") {
      heading = "Whitelist";
    }
    return heading;
  }, [toolType]);

  let totalPages = Math.ceil(Number(count) / filters.limit);

  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  const getDescription = () => {
    if (toolType === "whitelist") {
      return "Manage your whitelist of approved channels for content usage and distribution.";
    }
    return "Manage and resolve UGC (User Generated Content) claims on your music.";
  };

  return (
    <>
    <SEO
      title={heading}
      description={getDescription()}
    />
    <PageContainer>
      <Fade in timeout={800}>
        <Box>
          <PageHeader>
            <Typography variant="h1">{heading}</Typography>
          </PageHeader>

          {toolType === "ugc" && (
            <WarningCard>
              <WarningAmberIcon className="warning-icon" />
              <div className="warning-content">
                <h4><PolicyIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />Important Notice</h4>
                <p>
                  Misuse of this tool will result in immediate suspension of your account and services.
                  Please ensure all claims are legitimate and follow our guidelines. For questions or assistance,
                  contact us at <a href="mailto:support@fronicmedia.com">support@fronicmedia.com</a>
                </p>
              </div>
            </WarningCard>
          )}
          {toolType === "whitelist" && (
            <WarningCard>
              <WarningAmberIcon className="warning-icon" />
              <div className="warning-content">
                <h4><VerifiedUserIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />Beta Notice</h4>
                <p>
                  This tool is currently in Beta phase. Misuse will result in service suspension.
                  You may experience occasional issues during this testing period. We appreciate your patience.
                  For support, please reach out to <a href="mailto:support@fronicmedia.com">support@fronicmedia.com</a>
                </p>
              </div>
            </WarningCard>
          )}

          <Grid container justifyContent="center">
            <Grid item xs={12} lg={10} xl={8}>
              <FormCard>
                <Grid container spacing={3}>
          {toolType !== "whitelist" && (
            <>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Release<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  options={releases}
                  value={selectedRelease}
                  placeholder="Select Release"
                  onChange={setSelectedRelease}
                  menuPortalTarget={document.body}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Audio<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  options={songs}
                  value={selectedSong}
                  placeholder="Select Audio"
                  onChange={setselectedSong}
                  menuPortalTarget={document.body}
                />
              </Grid>
            </>
          )}

          {toolType === "ugc" && (
            <>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Platform<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  value={selectedPlatform || null}
                  options={platformOptions}
                  placeholder="Select Platform"
                  onChange={(e) =>
                    onHandleChange({
                      target: { name: "platform", value: e.value },
                    })
                  }
                  menuPortalTarget={document.body}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Policy<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  value={selectedPolicy || null}
                  options={policyOptions}
                  placeholder="Select Policy"
                  onChange={(e) =>
                    onHandleChange({
                      target: { name: "policy", value: e.value },
                    })
                  }
                  menuPortalTarget={document.body}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  URL<span className="required-span">*</span>
                </StyledInputLabel>
                <span
                  style={{
                    color: "#1a73e8",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                  onClick={() => onHandleModalView("url", data.url || [])}
                >
                  {(data.url && data.url.length) || 0} URL added (Click to
                  add)
                </span>
              </Grid>
            </>
          )}

          {/* ankush */}

          {toolType === "whitelist" && (
            <>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Platform<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  value={selectedWhitelistPlatform || null}
                  options={whitelistPlatformOptions}
                  placeholder="Select Platform"
                  onChange={(e) =>
                    onHandleChange({
                      target: { name: "whitelistPlatform", value: e.value },
                    })
                  }
                  menuPortalTarget={document.body}
                />
                <Box mt={3}>
                  <StyledInputLabel>
                    Channel Name<span className="required-span">*</span>
                  </StyledInputLabel>
                  <CssTextField
                    variant="outlined"
                    name="channel_name"
                    fullWidth
                    placeholder={`Enter the channel name`}
                    size="small"
                    value={data.channel_name || ""}
                    onChange={(e) => onHandleChange(e)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Select Channel Type<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  value={selectedWhitelistChannel || null}
                  options={whitelistchannelOptions}
                  placeholder="Select Channel Type"
                  onChange={(e) =>
                    onHandleChange({
                      target: { name: "channel_type", value: e.value },
                    })
                  }
                  menuPortalTarget={document.body}
                />
                <Box mt={3}>
                  <StyledInputLabel>
                    URL<span className="required-span">*</span>
                  </StyledInputLabel>
                  <CssTextField
                    variant="outlined"
                    name="URL"
                    fullWidth
                    placeholder={`Enter URL`}
                    size="small"
                    value={data.URL || ""}
                    onChange={(e) => onHandleChange(e)}
                  />
                </Box>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <StyledButton onClick={onSubmitForm}>
                <SaveIcon style={{ marginRight: "8px", fontSize: 17 }} /> Submit
              </StyledButton>
            </Box>
          </Grid>
        </Grid>
              </FormCard>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <SectionTitle>
                <HistoryIcon sx={{ color: '#1a73e8', fontSize: 28, mr: 1, verticalAlign: 'text-bottom' }} />
                Your {heading} History
              </SectionTitle>
        <Box mt={4}>
          <StyledTableContainer component={Paper}>
            <Table>
              <StyledTableHead>
                <TableRow>
                  {toolType !== "whitelist" && (
                    <>
                      <TableCell>Release Title</TableCell>
                      <TableCell>Audio Title</TableCell>
                    </>
                  )}
                  {toolType === "whitelist" && (
                    <>
                      <TableCell>Platform</TableCell>
                      <TableCell>Channel Type</TableCell>
                      <TableCell>Channel Name</TableCell>
                    </>
                  )}
                  {toolType === "ugc" && <TableCell>Policy</TableCell>}
                  <TableCell>Status</TableCell>
                  <TableCell>Date</TableCell>
                  {toolType === "ugc" && <TableCell>URLs</TableCell>}
                  {toolType === "whitelist" && <TableCell>URL</TableCell>}
                </TableRow>
              </StyledTableHead>

              <TableBody>
                {Array.isArray(dataHistory) && dataHistory.length
                  ? dataHistory.map((item, index) => {
                      return (
                        <StyledTableRow key={index}>
                          {toolType === "whitelist" && (
                            <>
                              <TableCell>{item.platform || ""}</TableCell>
                              <TableCell>{item.channel_type || ""}</TableCell>
                              <TableCell>{item.channel_name || ""}</TableCell>
                            </>
                          )}
                          {toolType !== "whitelist" && (
                            <>
                              <TableCell>{item.release_title || ""}</TableCell>
                              <TableCell>{item.audio_title || ""}</TableCell>
                            </>
                          )}
                          {toolType === "ugc" && (
                            <TableCell>{item.policy}</TableCell>
                          )}
                          <TableCell align="left">
                            <p>
                              {item.status === "in_review" ? (
                                <LightTooltip title="In Review">
                                  <AccessTimeIcon />
                                </LightTooltip>
                              ) : item.status === "rejected" ? (
                                <LightTooltip title="Rejected">
                                  <CancelIcon style={{ color: "red" }} />
                                </LightTooltip>
                              ) : (
                                <LightTooltip title="Approved">
                                  <CheckCircleIcon style={{ color: "green" }} />
                                </LightTooltip>
                              )}
                            </p>
                          </TableCell>
                          <TableCell>{item.date || ""}</TableCell>
                          {toolType === "whitelist" && (
                            <TableCell>
                              <span
                                style={{
                                  color: "#1a73e8",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontFamily: "'DM Sans', sans-serif",
                                  textDecoration: "none",
                                }}
                                onClick={() => window.open(item.URL, "_blank")}
                                onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                                onMouseOut={(e) => e.target.style.textDecoration = "none"}
                              >
                                Click To Open
                              </span>
                            </TableCell>
                          )}
                          {toolType === "ugc" && (
                            <TableCell>
                              {item.url && !!item.url.length ? (
                                <span
                                  style={{
                                    color: "#1a73e8",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontFamily: "'DM Sans', sans-serif",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    renderModalViewContent("urls", item.url)
                                  }
                                  onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                                  onMouseOut={(e) => e.target.style.textDecoration = "none"}
                                >
                                  {item.url.length} URL
                                </span>
                              ) : (
                                <span style={{ color: "#5f6368", fontFamily: "'DM Sans', sans-serif" }}>No URL</span>
                              )}
                            </TableCell>
                          )}
                        </StyledTableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
              <Pagination
                count={totalPages}
                showFirstButton
                showLastButton
                onChange={onPageChange}
                page={filters.page || 0}
                sx={{
                  '& .MuiPaginationItem-root': {
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: 600,
                    color: '#1a73e8',
                  },
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
                    color: 'white',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
                    },
                  },
                }}
              />
            </Box>
          </StyledTableContainer>
        </Box>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </PageContainer>
      <CustomShowModal
        open={guidelinesOpen}
        handleClose={() => setGuidelinesOpen(false)}
        maxWidth="sm"
        title="GUIDELINES"
      >
        {guidelinesToolsArray.map((item, key) => {
          return (
            <div style={{ display: "flex", padding: 5 }} key={key}>
              {key !== 0 ? (
                <span style={{ fontWeight: 600, marginRight: 5 }}>{key}.</span>
              ) : null}
              <p> {item}</p>
            </div>
          );
        })}
      </CustomShowModal>

      <CustomShowModal
        open={!!modalViewType.type}
        handleClose={() => setModalViewType({ type: "", urls: [] })}
        maxWidth="sm"
        title={modalViewType.type === "moods" ? "Select Moods" : "Add Url(s)"}
        description={
          toolType === "ugc"
            ? "Please remove '&feature=youtu.be' from your URL or the claim will not be released."
            : ""
        }
      >
        {generateModalContent(modalViewType, onChangeUrls, onAddUrls)}
      </CustomShowModal>

      <CustomShowModal
        open={modalContentView.show}
        handleClose={() =>
          setModalContentView({ show: false, component: null })
        }
        maxWidth="sm"
        title="View"
      >
        {modalContentView.component}
      </CustomShowModal>
      <CustomShowModal
        open={viewDetailsModal}
        handleClose={() => setViewDetailsModal(false)}
        maxWidth="sm"
        title={detailsData?.release_title || "Details"}
      >
        {toolType === "playlist" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Artwork Assets:</strong>
              <br />
              <a href={detailsData?.artwork_asset}>
                {detailsData?.artwork_asset}
              </a>
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Assets:</strong>
              <br />
              <a href={detailsData?.additional_assets}>
                {detailsData?.additional_assets}
              </a>
            </p>
            <strong>Moods:</strong>
            <ul>
              {detailsData?.moods.map((item) => {
                return <li>{item}</li>;
              })}
            </ul>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Your Pitch:</strong>
              <br />
              {detailsData?.why_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Quick Pitch:</strong>
              <br />
              {detailsData?.quick_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Information:</strong>
              <br />
              {detailsData?.additional_info}
            </p>
          </div>
        )}

        {toolType === "lyrics" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Publishing rights:</strong>
              <br />
              {detailsData?.p_rights}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>ISWC:</strong>
              <br />
              {detailsData?.iswc}
            </p>
            {/* <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <a
                href={detailsData?.lrc_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Download LRC</strong>
              </a>
            </p> */}

            <p style={{ whiteSpace: "break-spaces", paddingBottom: "5px" }}>
              <strong>Lyrics:</strong>
              <br />
              {detailsData?.lyrics}
            </p>
          </div>
        )}
      </CustomShowModal>
    </>
  );
}

const generateModalContent = (viewType, onChangeUrls, onAddUrls) => {
  const { type = "", urls = [] } = viewType;
  return (
    <Box>
      {type === "moods" ? (
        <>
          <Box style={{ gap: "10px" }} display="flex" flexWrap="wrap">
            {moodsOptions.map((item) => {
              const isSelected = urls.includes(item);
              if (isSelected) {
                return (
                  <Chip
                    label={item}
                    onDelete={() => onChangeUrls("delete", type, item, null)}
                    color="primary"
                  />
                );
              }
              return (
                <Chip
                  label={item}
                  onClick={() => onChangeUrls("update", type, item, null)}
                />
              );
            })}
          </Box>
          <Box mt={3} textAlign="center">
            {urls.length ? <span>{urls.length} Moods selected</span> : null}
          </Box>
        </>
      ) : (
        urls.map((item, index) => {
          const isValid = isValidUrl(item);
          return (
            <Box
              key={index}
              mb={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CssTextField
                variant="outlined"
                fullWidth
                placeholder={`Enter url ${index + 1}`}
                size="small"
                value={item}
                error={!isValid}
                onChange={(e) =>
                  onChangeUrls("update", type, e.target.value, index)
                }
              />
              {urls.length - 1 !== index || index > 8 || !isValid ? (
                <RemoveIcon
                  className="add-icon-button delete"
                  onClick={() => onChangeUrls("delete", type, null, index)}
                />
              ) : (
                <AddIcon
                  className="add-icon-button"
                  onClick={() => onChangeUrls("add", type, null, null)}
                />
              )}
            </Box>
          );
        })
      )}
      <Box mt={3} display="flex" justifyContent="center">
        <StyledButton onClick={onAddUrls}>Save</StyledButton>
      </Box>
    </Box>
  );
};
